"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expand = void 0;

var _isPlainObject = _interopRequireDefault(require("is-plain-object"));

var _invariant = _interopRequireDefault(require("fbjs/lib/invariant"));

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var expand = function expand(raw) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _defaultExpandOpts$op = _objectSpread({}, _util.defaultExpandOpts, opts),
      createBlock = _defaultExpandOpts$op.createBlock;

  (0, _invariant.default)((0, _isPlainObject.default)(raw), 'Raw contentState must be a plain object.');
  var blocks = raw.blocks.reduce(function (acc, block) {
    if ((0, _util.isNullish)(block)) {
      return acc;
    }

    if (typeof block === 'string') {
      acc.push(createBlock({
        text: block
      }));
    } else if ((0, _util.isCompact)(block)) {
      acc.push(createBlock(block));
    } else {
      acc.push(block);
    }

    return acc;
  }, []);
  return {
    blocks: blocks,
    entityMap: raw.entityMap || {}
  };
};

exports.expand = expand;